<template>
    <div class="customer-birthday">
        <!-- 顶部Tab -->
        <div class="tabs-container">
            <div v-for="(tab, index) in tabs" :key="index" class="tab-item" :class="{ active: currentTab === index }"
                @click="changeTab(index)">
                <span class="tab-text">{{ tab.name }}</span>
                <div v-if="currentTab === index" class="active-line"></div>
            </div>
        </div>

        <!-- 列表区域 -->
        <div class="list-container" @scroll="handleScroll" ref="scrollRef">
            <div v-for="item in list" :key="item.id" class="customer-card">
                <div class="card-top">
                    <div class="card-left">
                        <img class="avatar" :src="item.avatar" />
                    </div>
                    <div class="card-right">
                        <div class="name">{{ item.name }}</div>
                        <div class="info">
                            <span class="gender">男</span>
                            <span class="age">{{ item.age }}岁</span>
                        </div>
                    </div>
                </div>
                <div class="card-bottom">
                    <div class="phone-item">
                        <span class="phone">手机号码：{{ item.phone }}</span>
                        <img src="../../assets/img/icons/phoneicon-1.png" alt="电话" class="icon-img">
                    </div>
                    <div class="birthday-item">
                        <span>生&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;日：{{ item.birthday }}</span>
                    </div>
                    <div class="tag-item">
                        <span class="tag">标&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;签：</span>
                        <div class="tag-container">
                            <span v-for="tag in item.tags" :key="tag" class="tag-item">{{ tag }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="no-more" v-if="!finished && !loading && list.length === 0">暂无数据</div>
            <!-- 加载状态 -->
            <div class="loading" v-if="loading">加载中...</div>
            <div class="no-more" v-if="finished">没有更多了</div>

        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import operationapi from "@/utils/api/operation"
import { showToast } from 'vant';
const currentTab = ref(0)
const tabs = [
    { name: "本月" ,birthday_from:"",birthday_to:""},
    { name: "下月" ,birthday_from:"",birthday_to:""}
]

const list = ref([])
const page = ref(1)
const pageSize = 10
const loading = ref(false)
const finished = ref(false)
const scrollRef = ref < HTMLElement | null > (null)
const departmentdata = JSON.parse(localStorage.getItem("departmentdata"))
console.log(departmentdata)

const fetchList = async () => {
    if (loading.value || finished.value) return
    loading.value = true
    try {
        const res = await operationapi.getCustomerBirthdayList({
            birthday_from: tabs[currentTab.value].birthday_from,
            birthday_to: tabs[currentTab.value].birthday_to,
            shop_uuid: departmentdata?.department_uuid,
            page: page.value,
            page_size: pageSize
        })
        const records = res?.data || []
        // 追加数据
        list.value.push(...records)
        // 判断是否还有下一页
        if (records.length < pageSize) {
            finished.value = true
        } else {
            page.value++
        }
    } catch (error) {
        showToast(error.message || '获取客户生日列表失败')
    } finally {
        loading.value = false
    }
}

/**
 * 滚动到底部加载
 */
const handleScroll = () => {
    const el = scrollRef.value
    if (!el) return
    const bottom =
        el.scrollHeight - el.scrollTop - el.clientHeight < 20

    if (bottom) {
        fetchList()
    }
}

/**
 * 切换Tab重置列表
 */
const changeTab = (index) => {
    currentTab.value = index
    list.value = []
    page.value = 1
    finished.value = false
    fetchList()
}
//获取当前月份的开始日期和结束日期&&下月的开始日期和结束日期
const getMonthData = () => {
    const date = new Date()
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const nextMonth = month + 1
    const nextYear = month === 12 ? year + 1 : year
    const firstDay = `${year}-${month < 10 ? '0' + month : month}-01`
    const lastDay = `${year}-${month < 10 ? '0' + month : month}-${new Date(year, month, 0).getDate()}`
    const nextFirstDay = `${nextYear}-${nextMonth < 10 ? '0' + nextMonth : nextMonth}-01`
    const nextLastDay = `${nextYear}-${nextMonth < 10 ? '0' + nextMonth : nextMonth}-${new Date(nextYear, nextMonth, 0).getDate()}`
    tabs[0].birthday_from = firstDay
    tabs[0].birthday_to = lastDay
    tabs[1].birthday_from = nextFirstDay
    tabs[1].birthday_to = nextLastDay
    fetchList()
}
onMounted(() => {
    getMonthData()
})
</script>

<style scoped lang="less">
@color-primary: #333;
@color-orange: #DCBB89;

.customer-birthday {
    min-height: 100vh;
    font-family: -apple-system, BlinkMacSystemFont, "PingFang SC",
        "Helvetica Neue", Arial, sans-serif;
    color: @color-primary;
    background: #f5f5f5;
}

/* ===== 顶部Tab ===== */
.tabs-container {
    display: flex;
    justify-content: center;
    background: #fff;
    padding: 0 10px;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 10;

    .tab-item {
        position: relative;
        padding: 13px 8px;
        font-size: 15px;
        color: #999;
        width: 50%;
        text-align: center;

        &.active {
            color: @color-orange;
            font-weight: 600;
        }

        .active-line {
            position: absolute;
            bottom: 8px;
            left: 50%;
            transform: translateX(-50%);
            width: 40px;
            height: 3px;
            background-color: #dcb36d;
            border-radius: 2px;
        }
    }
}

/* ===== 列表 ===== */
.list-container {
    margin-top: 50px; // 避开fixed tab
    height: calc(100vh - 50px);
    overflow-y: auto;
    padding: 10px;

    .customer-card {
        background: #ffffff;
        border-radius: 14px;
        padding: 16px;
        margin-bottom: 12px;

        .card-top {
            display: flex;
            border-bottom: 2px solid #f2f2f2;

            .card-left {
                margin-right: 13px;

                .avatar {
                    width: 51px;
                    height: 51px;
                    border-radius: 50%;
                }
            }

            .card-right {
                .name {
                    font-size: 22px;
                    font-weight: 600;
                    color: #333;
                }

                .info {
                    font-size: 17px;
                    color: #666666;

                    .gender {
                        margin-right: 12px;
                    }
                }
            }
        }

        .card-bottom {
            margin-top: 18px;
            color: #666;
            font-size: 19px;

            .phone-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 5px;

                .icon-img {
                    width: 31px;
                    height: 31px;
                }
            }

            .birthday-item {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 5px;
            }

            .tag-item {
                display: flex;
                align-items: start;
                justify-content: flex-start;
                margin-bottom: 5px;

                .tag-container {
                    display: flex;
                    flex-wrap: wrap;

                    .tag-item {
                        border: 1px solid #dcb36d;
                        border-radius: 5px;
                        color: #9A753E;
                        background: #F3EDE3;
                        padding: 2px 6px;
                        font-size: 14px;
                        margin-right: 5px;
                        display: table-cell;
                    }
                }

            }
        }

    }
}

.loading,
.no-more {
    text-align: center;
    padding: 15px 0;
    color: #999;
    font-size: 16px;
}
</style>